"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCloudResultstoFileResults = void 0;
var core_1 = require("@newfront-insurance/core");
var download_email_filename_1 = require("./download-email-filename");
var google_search_get_text_value_1 = require("./google-search-get-text-value");
function formatCloudResultstoFileResults(cloudSearchResults, archiveFile, downloadFile, unarchiveFile) {
    var _this = this;
    return cloudSearchResults.map(function (cloudSearchResult) {
        var _a;
        var fieldMap = (0, core_1.toMap)((_a = cloudSearchResult.metadata.fields) !== null && _a !== void 0 ? _a : [], function (field) { return field.name; });
        var category = (0, google_search_get_text_value_1.getSingleTextValue)(fieldMap, 'category');
        var fileId = (0, google_search_get_text_value_1.getSingleTextValue)(fieldMap, 'fileId');
        var fileName = (0, google_search_get_text_value_1.getSingleTextValue)(fieldMap, 'fileName'); // original file name
        var fileStatus = (0, google_search_get_text_value_1.getSingleTextValue)(fieldMap, 'fileStatus');
        var isEmail = (category === null || category === void 0 ? void 0 : category.toLowerCase()) === 'email';
        return {
            associations: null,
            category: category,
            createdAt: cloudSearchResult.metadata.createTime,
            createdByUserId: (0, google_search_get_text_value_1.getSingleTextValue)(fieldMap, 'createdByUserId'),
            fileId: fileId,
            fileName: fileName,
            objectReferenceIds: (0, google_search_get_text_value_1.getMultiTextValue)(fieldMap, 'objectRefIds'),
            objectReferenceTypes: (0, google_search_get_text_value_1.getMultiTextValue)(fieldMap, 'objectRefTypes'),
            status: fileStatus,
            summary: (0, google_search_get_text_value_1.getSingleTextValue)(fieldMap, 'metaSummary'),
            updatedAt: cloudSearchResult.metadata.updateTime,
            updatedByUserId: (0, google_search_get_text_value_1.getSingleTextValue)(fieldMap, 'updatedByUserId'),
            archive: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, archiveFile(fileId)];
            }); }); },
            download: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, downloadFile(fileId, 'attachment', false, isEmail ? (0, download_email_filename_1.getDownloadEmailFilename)(fileId, fileName) : undefined)];
            }); }); },
            preview: function (newTab) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, downloadFile(fileId, 'inline', newTab || false)];
            }); }); },
            unarchive: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, unarchiveFile(fileId)];
            }); }); },
        };
    });
}
exports.formatCloudResultstoFileResults = formatCloudResultstoFileResults;
